import type { ErrorResponse } from '~~/src/types/api'

export class APIError extends Error implements ErrorResponse {
  status: number
  data: any
  errorMessage: string
  errorInfo?: string | undefined
  isToast: boolean
  constructor(message: string, status: number, data?: any, isToast = false) {
    super(message)
    this.status = status
    this.data = data
    this.errorMessage = message
    this.isToast = isToast
  }
}
